export default "__VITE_ASSET__17b7523a__"